import React from "react";

export const RenderErrorContent = ({msg='Can\'t Render the Page'}) => {
    return (
        <div className="w-full flex flex-col h-full justify-center items-center">
            <img src="https://asserts.engage.gozen.io/v1/public/not-found.png" alt="Engage Error Logo"/>
            <h2 className=" engage-broken-text ">{msg}</h2>
        </div>
    )
} 